module.exports = __webpack_public_path__ + "img/spiel3.52c673a2.jpg";